<template>
  <v-container grid-list-sm>
    <v-layout row wrap>
      <v-card elevation="0" class="pt-0">
        <v-card-text fill-height class="pt-0">
          <v-container fluid grid-list-sm class="pa-0">
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  label="Address"
                  v-model="fields.billing_address"
                  append-icon="fa-home"
                  box
                  hide-details
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="City"
                  v-model="fields.billing_city"
                  append-icon="fa-compass"
                  box
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <StateField
                  v-model="fields.billing_state"
                  icon="fa-info-circle"
                  :textfield="fields.billing_country !== 'USA'"
                ></StateField>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Postal Code"
                  v-model="fields.billing_postalcode"
                  :rules="transaction.payment_type !== 'ach' ? postalcodeRules : []"
                  append-icon="fa-info-circle"
                  box
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Phone"
                  v-model="fields.billing_phone"
                  mask="(###) ###-####"
                  append-icon="fa-phone"
                  box
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Email"
                  v-model="fields.billing_email"
                  append-icon="fa-at"
                  :rules="emailRules"
                  box
                  hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-container fluid grid-list-lg class="pa-0">
            <v-layout row wrap>
              <v-spacer></v-spacer>
              <v-flex xs3>
                <v-btn block large @click="closeModal">Cancel</v-btn>
              </v-flex>
              <v-flex xs3>
                <v-btn block large color="primary" :disabled="!submitDisabled">Confirm</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import Bus from '@/bus'

import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import CashDiscountMixin from '@/mixins/cashDiscount'
import DisplayMixin from '@/mixins/display'
import RecurringMixin from '@/mixins/recurring'
import StoreMixin from '@/store/mixin'
import UtilityMixin from '@/mixins/utility'

import StateField from '@/components/forms/StateDropdown.vue'

export default {
  components: { StateField },

  mixins: [
    ApiMixin,
    AuthMixin,
    CashDiscountMixin,
    DisplayMixin,
    RecurringMixin,
    StoreMixin,
    UtilityMixin
  ],

  data: function () {
    return {
      enabled: false,

      fields: {
        test: '',
        token: null,
        billing_address: '',
        billing_address_original: '',
        billing_city: '',
        billing_city_original: '',
        billing_state: '',
        billing_state_original: '',
        billing_postalcode: '',
        billing_postalcode_original: '',
        billing_country: '',
        billing_country_original: '',
        billing_phone: null,
        billing_phone_original: null,
        billing_email: null,
        billing_email_original: null
      },

      addressRules: [
        (v) => !!v || 'Address is required'
      ],
      cityRules: [
        (v) => !!v || 'City is required'
      ],
      stateRules: [
        (v) => !!v || 'State is required'
      ],
      postalcodeRules: [
        (v) => !!v || 'Postal code is required'
      ],
      emailRules: [
        (v) => !v || /.+@.+/.test(v) || 'Email must be valid'
      ]
    }
  },

  props: {
    terminal: Object,
    transaction: Object
  },

  // beforeDestroy () {},

  // mounted () {
  //   this.load()
  // },

  // updated () {
  //   this.load()
  // },

  watch: {
    transaction: function () {
      this.load()
    }
  },

  computed: {
    submitDisabled: function () {
      return this.fields.billing_address !== this.fields.billing_address_original ||
        this.fields.billing_city !== this.fields.billing_city_original ||
        this.fields.billing_state !== this.fields.billing_state_original ||
        this.fields.billing_postalcode !== this.fields.billing_postalcode_original ||
        this.fields.billing_country !== this.fields.billing_country_original ||
        this.fields.billing_phone !== this.fields.billing_phone_original ||
        this.fields.billing_email !== this.fields.billing_email_original
    }
  },

  methods: {
    closeModal () {
      Bus.$emit('closeModifyModal')
    },

    async load () {
      this.fields.billing_address_original = this.fields.billing_address = this.transaction.billing_address
      this.fields.billing_city_original = this.fields.billing_city = this.transaction.billing_city
      this.fields.billing_state_original = this.fields.billing_state = this.transaction.billing_state
      this.fields.billing_postalcode_original = this.fields.billing_postalcode = this.transaction.billing_postal_code
      this.fields.billing_country_original = this.fields.billing_country = this.transaction.billing_country
      this.fields.billing_phone_original = this.fields.billing_phone = this.transaction.billing_phone
      this.fields.billing_email_original = this.fields.billing_email = this.transaction.billing_email
    },

    async save () {
      try {
        Bus.$emit('openWaitModal')

        /*
          Send to FAPS:
            Zip
            Email
            Phone

          Recreate billing
        */

        let options = {
          account_id: this.transaction.account_id,
          terminal_id: this.transaction.terminal_id,
          // transaction_id: this.transaction.custom_tracking_id,
          unique_id: this.transaction.tracking_id,
          token_id: this.transaction.token_id,
          billing_id: this.transaction.billing_id,
          total_amount: ((this.transaction.modify_total_amount ? this.transaction.modify_total_amount : this.transaction.total_amount) - (this.transaction.modify_fee_amount ? this.transaction.modify_fee_amount : this.transaction.fee_amount)) / 100, // required for FAPS
          fee_amount: (this.transaction.modify_fee_amount ? this.transaction.modify_fee_amount : this.transaction.fee_amount) / 100 // required for modify endpoint to properly calculate total
        }

        if (this.fields.billing_address !== this.fields.billing_address_original) {
          options.billing_address = this.fields.billing_address
        }
        if (this.fields.billing_city !== this.fields.billing_city_original) {
          options.billing_city = this.fields.billing_city
        }
        if (this.fields.billing_state !== this.fields.billing_state_original) {
          options.billing_state = this.fields.billing_state
        }
        if (this.fields.billing_postalcode !== this.fields.billing_postalcode_original) {
          options.billing_postalcode = this.fields.billing_postalcode
        }
        if (this.fields.billing_phone !== this.fields.billing_phone_original) {
          options.billing_phone = this.fields.billing_phone
        }
        if (this.fields.billing_email !== this.fields.billing_email_original) {
          options.billing_email = this.fields.billing_email
        }

        let result = await this.api({
          method: 'post',
          url: `/terminal/modify`,
          data: options
        })

        if (result.data) {
          if (result.data.response.ResponseText === 'MODIFY ACCEPTED') {
            Bus.$emit('openModal', {status: 'success', message: 'Billing Details Saved'})
            Bus.$emit('closeOptionsModal')
          } else {
            let error = result.data.response.ResponseText
            if (result.data.response.ErrMsg) {
              error += ': ' + result.data.response.ErrMsg
            }
            throw new Error(error)
          }
        } else {
          Bus.$emit('openModal', {status: 'error', message: 'Unexpected Error'})
        }

        // @TODO modify last payment if there is one
      } catch (err) {
        Bus.$emit('openModal', {status: 'error', message: err})
      } finally {
        Bus.$emit('closeWaitModal')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/plans/ModifyBilling.vue